import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Typography from '@mui/material/Typography';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import IconButton from '@mui/material/IconButton';
import {researchAction} from '../../../services/ResearchServices';
import {DispatchContext} from '../../../store';
import {SNACKBAR_OPEN} from '../../../reducers';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function DeleteResearchDialog({open, handleAction, researchId, researchMaterial, setResearchMaterial}) {
  const dispatch = useContext(DispatchContext);

  const handleSubmit = () => {
    researchAction('delete', researchId).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Research material deleted successfully'}
      });
      handleAction();
      let research = researchMaterial?.find(research => research?.id === researchId);
      let index = researchMaterial?.indexOf(research);
      researchMaterial?.splice(index, 1)
      setResearchMaterial(researchMaterial);
    });
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle sx={{backgroundColor: '#f85454', height: 1}}/>
      <DialogContent className={'text-center'}>
        <IconButton sx={{backgroundColor: '#fce7e7', marginTop: 3}}>
          <ReportProblemIcon sx={{fontSize: 30, color: 'red'}}/>
        </IconButton>
        <Typography color={'#616B88'} sx={{fontSize: 25, marginTop: 2}} className={'text-bold text-center'}
                    fontWeight={700}>
          Are You Sure!
        </Typography>
        <Typography>
          This action cannot be undone.
        </Typography>
        <Typography>
          All values associated with this user will be lost.
        </Typography>
      </DialogContent>
      <div className={'header-divider'}/>
      <DialogActions>
        <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}>Cancel</Button>
        <Button variant={'contained'} onClick={handleSubmit} className={'text-capitalize'}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}